// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Y_-z","narrowOptionButtons":"Z_-z","noOptions":"__-z"};